import React from "react";
import { Table } from "antd";
import { useSelector } from "react-redux";
import dayjs from "dayjs";
const ReportsInfoTable = () => {
  const { reportsStatistics, loadingReportsStatistics } = useSelector(
    (state) => state.reportsStatisticsReducer
  );

  const getTotalFromTableColumns = (type) => {
    return reportsStatistics
      ?.map((item) => {
        return item[type];
      })
      ?.reduce((accumulator, currentValue) => accumulator + currentValue, 0)
      ?.toFixed(2);
  };

  const columns = [
    {
      title: "Дата на отчета",
      dataIndex: "reportDate",
      key: "reportDate",
      render: (created) => <span>{dayjs(created).format("DD-MM-YYYY")}</span>,
      sorter: (a, b) => dayjs(b.reportDate) - dayjs(a.reportDate),
      align: "left",
    },
    {
      title: "Дата на създаване",
      dataIndex: "created",
      key: "created",
      render: (created) => (
        <span>{dayjs(created).format("DD.MM - HH:mm:ss")}</span>
      ),
      sorter: (a, b) => dayjs(b.created) - dayjs(a.created),
      align: "center",
    },
    {
      title: `Брой ${getTotalFromTableColumns("cash")}`,
      dataIndex: "cash",
      key: "cash",
      render: (cash) => <span>{cash.toFixed(2)}</span>,
      sorter: (a, b) => b.cash - a.cash,
      align: "center",
    },
    {
      title: `Карта ${getTotalFromTableColumns("card")}`,
      dataIndex: "card",
      key: "card",
      render: (card) => <span>{card.toFixed(2)}</span>,
      sorter: (a, b) => b.card - a.card,
      align: "center",
    },
    {
      title: `Други ${getTotalFromTableColumns("other")}`,
      dataIndex: "other",
      key: "other",
      render: (other) => <span>{other.toFixed(2)}</span>,
      sorter: (a, b) => b.other - a.other,
      align: "center",
    },
    {
      title: `Обща сума ${getTotalFromTableColumns("total")}`,
      dataIndex: "total",
      key: "total",
      render: (total) => <span>{total.toFixed(2)}</span>,
      sorter: (a, b) => b.total - a.total,
      align: "right",
    },
  ];

  return (
    <div className="reports-info-table-container">
      <Table
        rowKey="created"
        pagination={{
          defaultPageSize: 50,
          showSizeChanger: true,
          pageSizeOptions: ["10", "25", "50", "100"],
        }}
        loading={loadingReportsStatistics}
        className="reports-info-table"
        dataSource={reportsStatistics}
        columns={columns}
      />
    </div>
  );
};

export default ReportsInfoTable;
